import clsx from 'clsx'
import { forwardRef } from 'react'

export const Field = ({ label, hint, error, children }) => (
  <div className="mb-4">
    {label && (
      <label className="block text-[11px] font-semibold tracking-wide uppercase text-muted mb-1.5">
        {label}
      </label>
    )}
    {children}
    {hint && !error && <p className="mt-1.5 text-[12px] text-muted-2">{hint}</p>}
    {error && <p className="mt-1.5 text-[12px] text-danger">{error}</p>}
  </div>
)

const Input = forwardRef(function Input({ className, error, icon: Icon, ...props }, ref) {
  return (
    <div className="relative">
      {Icon && <Icon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-2" />}
      <input
        ref={ref}
        className={clsx(
          'w-full h-11 rounded-md bg-panel2 border text-ink placeholder:text-muted-2',
          'transition-colors duration-150 outline-none',
          Icon ? 'pl-9 pr-3' : 'px-3',
          error ? 'border-danger' : 'border-line focus:border-blue',
          className
        )}
        {...props}
      />
    </div>
  )
})

export default Input
